import { Divider, Grid, makeStyles, Typography } from '@freighthub/silhouette-core'
import { InsuranceQR } from 'features/BookingFlow'
import { ShipmentMode } from 'features/ShipmentDetails'
import { FC, ReactNode } from 'react'
import { formatNumber } from 'service/NumberFormatter'
import { useI18n } from 'utils/localisation'

type ServiceProps = {
  title: string
  value: ReactNode
}
export const MQService: FC<ServiceProps> = ({ title, value }) => {
  return (
    <>
      <Grid xs={3}>
        <Typography variant="subtitle1">{title}</Typography>
      </Grid>
      <Grid xs={9}>{value}</Grid>
      <Grid xs={12}>
        <Divider />
      </Grid>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  itype: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
    width: 'fit-content',
  },
}))

type InsuranceValuesProps = {
  insurances: InsuranceQR[]
}

const getCurrency = (code: string): string => {
  switch (code) {
    case 'EUR':
      return '€'
    case 'USD':
      return '$'
    default:
      return code
  }
}

const InsuranceValues: FC<InsuranceValuesProps> = ({ insurances }) => {
  const classes = useStyles()
  const { translate } = useI18n()

  return (
    <>
      {insurances.map((ins) =>
        ins.value ? (
          <Typography align="center" color="textSecondary" key={ins.value} className={classes.itype}>
            {`${translate('manual_quote-insurance-commodity_class', { class: ins.id })} ${formatNumber(
              Number(ins.value)
            )} ${getCurrency(ins.currency)}`}
          </Typography>
        ) : null
      )}
    </>
  )
}

type MQServicesProps = {
  hasCustomsService?: boolean
  transportMode: ShipmentMode
  insurance?: InsuranceQR[]
  hsCodesCount?: number
}
const modeTerm: Record<ShipmentMode, string> = {
  sea: 'common-mode-sea',
  air: 'common-mode-air',
  seaAir: 'common-mode-sea_air',
  rail: 'common-mode-rail',
}
export const MQServices: FC<MQServicesProps> = ({
  transportMode,
  hasCustomsService = false,
  hsCodesCount,
  insurance,
}) => {
  const { translate } = useI18n()
  return (
    <>
      <MQService title={translate('manual_quote-modes-title')} value={translate(modeTerm[transportMode])} />
      <MQService
        title={translate('manual_quote-insurance-title')}
        value={
          insurance ? <InsuranceValues insurances={insurance} /> : translate('manual_quote-insurance-no_additional')
        }
      />
      <MQService
        title={translate('manual_quote-customs-title')}
        value={
          hasCustomsService
            ? translate('manual_quote-customs_yes-helper', { count: hsCodesCount })
            : translate('manual_quote-customs_no-helper')
        }
      />
    </>
  )
}
